export default "__VITE_ASSET__BKfq4w41__"